import styles from './App.module.scss';
import { jsPDF } from 'jspdf';
import { useState, useEffect } from 'react';
function App() {
  const [input, setInput] = useState('');
  const [batchInput, setBatchInput] = useState('');
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/jsbarcode@3.11.0/dist/JsBarcode.all.min.js';
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (!window.JsBarcode) return;
    const svg = document.getElementById('barcode');
    if (input.trim() === '') {
      svg.innerHTML = '';
      return;
    }
    window.JsBarcode(svg, input, {
      format: 'CODE128',
      lineColor: '#000',
      background: '#FFF',
      width: 2,
      height: 50,
      displayValue: true,
    });
  }, [input]);

  function updateInputValue(input) {
    if (input.length < 40) {
      setInput(input);
    }
  }

  function isSVGEmpty(svgElement) {
    return svgElement.children.length === 0;
  }

  function downloadSVGAsJPG() {
    const svgElement = document.getElementById('barcode');
    if (isSVGEmpty(svgElement)) {
      return;
    }
    const svgData = new XMLSerializer().serializeToString(svgElement);
    const svgBlob = new Blob([svgData], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(svgBlob);
    const image = new Image();
    image.onload = function () {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.width = svgElement.width.baseVal.value;
      canvas.height = svgElement.height.baseVal.value;
      context.drawImage(image, 0, 0);
      const jpgDataUrl = canvas.toDataURL('image/jpeg', 0.9);
      const link = document.createElement('a');
      link.href = jpgDataUrl;
      link.download = input;
      link.click();
    };
    image.src = url;
  }

  async function bundle() {
    const separators = /[,\.\s]+/;
    const items = Array.from(
      new Set(
        batchInput
          .split(separators)
          .map((x) => x.trim())
          .filter((x) => x !== ''),
      ),
    );
    if (items.length === 0) return;
    const pdf = new jsPDF({ unit: 'pt', format: 'a4' });
    const margin = 20;
    let y = margin;
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svg.style.position = 'absolute';
    svg.style.left = '-9999px';
    svg.style.top = '-9999px';
    document.body.appendChild(svg);

    async function svgToPNG(value) {
      return new Promise((resolve, reject) => {
        try {
          window.JsBarcode(svg, value, {
            format: 'CODE128',
            lineColor: '#000',
            background: '#FFF',
            width: 2,
            height: 50,
            displayValue: true,
          });
        } catch (err) {
          return reject('JsBarcode failed');
        }
        const bbox = svg.getBBox();
        if (bbox.width === 0 || bbox.height === 0) {
          return reject('Empty SVG');
        }
        svg.setAttribute('width', bbox.width);
        svg.setAttribute('height', bbox.height);
        const serialized = new XMLSerializer().serializeToString(svg);
        const blob = new Blob([serialized], { type: 'image/svg+xml' });
        const url = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = bbox.width;
          canvas.height = bbox.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          URL.revokeObjectURL(url);
          resolve({
            png: canvas.toDataURL('image/png'),
            width: bbox.width,
            height: bbox.height,
          });
        };

        img.onerror = () => reject('Image load error');
        img.src = url;
      });
    }

    for (const val of items) {
      try {
        const { png, width, height } = await svgToPNG(val);
        const maxWidth = 250;
        const scale = maxWidth / width;
        const finalWidth = width * scale;
        const finalHeight = height * scale;
        if (y + finalHeight + 20 > pdf.internal.pageSize.getHeight()) {
          pdf.addPage();
          y = margin;
        }
        const x = margin;
        pdf.addImage(png, 'PNG', x, y, finalWidth, finalHeight);
        y += finalHeight + 40;
      } catch (err) {
        console.error('Failed:', val, err);
        pdf.text(`ERROR rendering: ${val}`, margin, y);
        y += 30;
      }
    }
    svg.remove();
    pdf.save('barcodes.pdf');
  }
  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <div className={styles.topLevel}>
          <div>
            <button className={styles.button} onClick={() => setInput('AP-1-1A')}>
              IC
            </button>
            <button className={styles.button} onClick={() => setInput('HVY-3-1A')}>
              Laukas
            </button>
            <button className={styles.button} onClick={() => setInput('PRIEMIMAS')}>
              PPIS
            </button>
            <button className={styles.button} onClick={() => setInput('2030-01-01')}>
              Data
            </button>
          </div>
        </div>
        <div className={styles.midLevel}>
          <input
            type="text"
            id="codeInput"
            className={styles.codeInput}
            onInput={(e) => updateInputValue(e.target.value)}
            value={input}
            autoComplete="off"
          ></input>
          <button className={styles.button} onClick={() => downloadSVGAsJPG()}>
            Parsiųsti
          </button>
        </div>

        <div className={styles.bottomLevel}>
          <svg id="barcode"></svg>
        </div>
        <div className={styles.basementLevel}>
          <textarea
            className={styles.textArea}
            value={batchInput}
            onInput={(e) => setBatchInput(e.target.value)}
          ></textarea>
          <button className={styles.button} onClick={() => bundle()}>
            Sąrašas
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;
